import * as React from "react";
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { ValidatorForm } from 'react-material-ui-form-validator';
import { CircularProgress, Typography, Paper, Box, Avatar, Divider } from "@mui/material";
import TextField from "@material-ui/core/TextField";
import AlertDialog from "../../../../../components/AlertDialog/index.es6";
import ModalInc from "../../../../../shared-ui/ModalInc";
import { getPartnerGuid } from "../../../../../lib/access.es6";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PaymentsIcon from '@mui/icons-material/Payments';
import SendIcon from '@mui/icons-material/Send';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getPartner } from "../../../../../lib/access.es6";

// Primary color definition
const PRIMARY_COLOR = "#032a37";

export default function InitiatePayment(props) {
  if (!props.policy) {
    return "";
  }

  const [phoneNumber, setPhoneNumber] = React.useState(
    props.customer.currentCustomer.msisdn
  );
  const partner = getPartner();
  const currencyCode =
    partner && partner.country && partner.country.currency_code
      ? partner.country.currency_code
      : "N/A";

  console.log("props.policy", props.policy);
  console.log("customer", props.customer.currentCustomer.msisdn);
  console.log(
    "props.policy.total_payable_amount_as_at_today",
    props.policy.quotation.total_premium_amount_in_cents
  );

  const initiatePayment = () => {
    const paymentRequest = {
      policy_guid: props.policy.guid,
      amount_in_cents: props.policy.quotation.total_premium_amount_in_cents,
      partner: getPartnerGuid(),
      type: "strike_money",
      customer_guid: props.policy.customer_guid,
      policy_type: "complex",
      customer_reference: phoneNumber,
    };

    props.initiatePaymentRequest(paymentRequest);
  };

  const handleInitiatePaymentSuccessfully = () => {
    props.resetInitiatePolicy();
  };

  const handleInitiatePaymentError = () => {
    props.resetInitiatePolicy();
  };

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  return (
    <React.Fragment>
      {/* Processing Dialog */}
      <AlertDialog
        custom
        show={props.showInitiatePaymentProgressAlert}
        size="sm"
        style={{
          marginTop: "0",
          top: "30vh",
          borderRadius: "10px",
        }}
        confirmBtnText={"ok"}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={"cancel"}
        showTitle={false}
        confirmBtnCssClass
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 3,
          }}
        >
          <CircularProgress
            size={60}
            thickness={4}
            sx={{ mb: 2, color: PRIMARY_COLOR }}
          />
          <Typography
            variant="h6"
            component="h2"
            sx={{ fontWeight: 500, textAlign: "center", color: PRIMARY_COLOR }}
          >
            Initiating Payment Request
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 1, textAlign: "center" }}
          >
            Please wait while we process your request
          </Typography>
        </Box>
      </AlertDialog>

      {/* Success Dialog */}
      <AlertDialog
        success
        show={props.showInitiatePaymentSuccessAlert}
        size="sm"
        title={"Payment request initiated successfully"}
        style={{ marginTop: "0", top: "30vh" }}
        onConfirm={() => {
          handleInitiatePaymentSuccessfully();
        }}
        confirmBtnText={"Ok"}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={"Cancel"}
        confirmBtnCssClass
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 2,
          }}
        >
          <Typography variant="body1" sx={{ textAlign: "center", mb: 3 }}>
            A payment request has been sent. Customer will receive a payment
            prompt on their phone.
          </Typography>
          <ButtonInc
            variant="contained"
            onClick={() => {
              handleInitiatePaymentSuccessfully();
            }}
            sx={{
              background: PRIMARY_COLOR,
              borderRadius: "8px",
              px: 4,
              py: 1.2,
              fontWeight: 500,
              "&:hover": {
                background: "#054054",
              },
            }}
          >
            Close
          </ButtonInc>
        </Box>
      </AlertDialog>

      {/* Error Dialog */}
      <AlertDialog
        show={props.showInitiatePaymentErrorAlert}
        danger
        title={"Error initiating payment"}
        onConfirm={() => handleInitiatePaymentError()}
        confirmBtnText={"Try again"}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: "0", top: "30vh" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 2,
          }}
        >
          <Avatar sx={{ bgcolor: "error.main", width: 70, height: 70, mb: 2 }}>
            <ErrorOutlineIcon fontSize="large" />
          </Avatar>
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              mb: 1,
              fontWeight: 600,
              color: PRIMARY_COLOR,
            }}
          >
            Payment Request Failed
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              color: "error.main",
              fontWeight: 400,
              mb: 3,
            }}
          >
            {props.initiatePaymentError
              ? props.initiatePaymentError.message
              : "An unexpected error occurred"}
          </Typography>
          <ButtonInc
            variant="contained"
            onClick={() => handleInitiatePaymentError()}
            sx={{
              background: "#d32f2f",
              borderRadius: "8px",
              px: 4,
              py: 1.2,
              fontWeight: 500,
              "&:hover": {
                background: "#b71c1c",
              },
            }}
          >
            Try Again
          </ButtonInc>
        </Box>
      </AlertDialog>

      {/* Main Payment Dialog */}
      <ModalInc
        modalTitle="Initiate Payment"
        open={!!props.policy}
        onClose={() => props.resetInitiatePolicy()}
        fullWidth
      >
        <ValidatorForm onSubmit={() => initiatePayment()}>
          <Paper
            elevation={2}
            sx={{ p: 4, borderRadius: "12px", backgroundColor: "#fff" }}
          >
            {/* Premium Amount - Prominently Displayed */}
            <Box
              sx={{
                mb: 4,
                p: 3,
                bgcolor: PRIMARY_COLOR,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(3, 42, 55, 0.15)",
                color: "white",
                textAlign: "center",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ mb: 1, fontWeight: 400, opacity: 0.9 }}
              >
                Premium Amount
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                }}
              >
                <PaymentsIcon fontSize="large" />
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                  {currencyCode}{" "}
                  {props.policy.quotation.total_premium_amount_in_cents / 100}
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Phone Number Input */}
            <Typography
              variant="subtitle1"
              sx={{
                mb: 2,
                fontWeight: 500,
                color: PRIMARY_COLOR,
                textAlign: "center",
                textDecoration: "underline",
              }}
            >
              Enter the phone number to receive payment request
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 4,
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                placeholder="Enter phone number"
                InputProps={{
                  startAdornment: (
                    <PhoneAndroidIcon sx={{ color: PRIMARY_COLOR, mr: 1 }} />
                  ),
                }}
                sx={{
                  maxWidth: "400px",
                  margin: "0 auto",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    fontSize: "1.1rem",
                    "&.Mui-focused fieldset": {
                      borderColor: PRIMARY_COLOR,
                      borderWidth: "2px",
                    },
                    "& fieldset": {
                      borderColor: "rgba(3, 42, 55, 0.3)",
                    },
                    "&:hover fieldset": {
                      borderColor: "rgba(3, 42, 55, 0.5)",
                    },
                  },
                }}
              />
            </Box>

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                mt: 3,
              }}
            >
              <ButtonInc
                color="secondary"
                btnType="secondary"
                size="large"
                onClick={() => props.resetInitiatePolicy()}
                startIcon={<ArrowBackIcon />}
              >
                Cancel
              </ButtonInc>

              <ButtonInc
                variant="contained"
                color="primary"
                size="large"
                type="submit"
                endIcon={<SendIcon />}
                sx={{
                  borderRadius: "8px",
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  backgroundColor: PRIMARY_COLOR,
                  "&:hover": {
                    backgroundColor: "#054054",
                  },
                }}
              >
                Send Payment Request
              </ButtonInc>
            </Box>
          </Paper>
        </ValidatorForm>
      </ModalInc>
    </React.Fragment>
  );
}
